import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

var routes = [
  {
    path: '/',
    redirect: '/warning'
  },
  {
    path: '/coupon',
    name: 'CouponCampaign',
    component: function() {
      return import('@/views/coupon/CouponCampaign.vue')
    }
  },
  {
    path: '/warning',
    name: 'WarningMonitor',
    component: function() {
      return import('@/views/warning/WarningMonitor.vue')
    }
  }
]

var router = new VueRouter({
  routes: routes
})

export default router
